// src/utils/logger.ts
const matchDevExists = () => localStorage.getItem('matchid-sdk-react-debug') !== null;

const handler = {
    get(target: any, prop: string) {
        if (matchDevExists() && typeof target[prop] === 'function') {
            return target[prop].bind(console);
        }
        return () => {};
    }
};

const matchlog = new Proxy(console, handler);

export default matchlog;